import { assign, createMachine } from '@monofront/xstate-v4';
import { CHECKOUT_COM_CARD_FORM_STATES } from './states';
import { CHECKOUTCOM_CARD_FORM_TRANSITIONS } from './transitions';
import {
  ICheckoutComContext,
  ICheckoutComEvents,
  IFlowPaymentCompletedEvent,
  IOpen3DSecureEvent,
} from './types';

export const CHECKOUTCOM_CARD_FORM_MACHINE_ID = 'checkoutcom-card-form';

const open3DSecureModal = assign<ICheckoutComContext, IOpen3DSecureEvent>({
  is3DSecureOpen: (_, _event) => true,
  url3DSecure: (_, event) => event.url3DSecure,
  paymentId: (_, event) => event?.paymentId || null,
  saveCardForFutureUse: (_, event) => event?.saveCardForFutureUse || false,
});

const setFlowPaymentId = assign<ICheckoutComContext, IFlowPaymentCompletedEvent>({
  flowPaymentId: (_, event) => event.paymentId,
});

const initialContext: ICheckoutComContext = {
  is3DSecureOpen: false,
  url3DSecure: '',
  paymentId: null,
  saveCardForFutureUse: false,
  flowPaymentId: null,
};

export const checkoutcomCardFormMachine = createMachine<ICheckoutComContext>({
  id: CHECKOUTCOM_CARD_FORM_MACHINE_ID,
  initial: CHECKOUT_COM_CARD_FORM_STATES.INITIAL,
  context: initialContext,
  states: {
    [CHECKOUT_COM_CARD_FORM_STATES.INITIAL]: {
      entry: assign({
        ...initialContext,
      }),
      on: {
        [CHECKOUTCOM_CARD_FORM_TRANSITIONS.SUBMIT_CARD]: {
          target: [CHECKOUT_COM_CARD_FORM_STATES.CARD_TOKENIZED],
        },
        [CHECKOUTCOM_CARD_FORM_TRANSITIONS.FLOW_MOUNTED]: {
          target: [CHECKOUT_COM_CARD_FORM_STATES.FLOW_READY],
        },
      },
    },
    [CHECKOUT_COM_CARD_FORM_STATES.CARD_TOKENIZED]: {
      entry: ['notifyCardTokenized'],
      on: {
        [CHECKOUTCOM_CARD_FORM_TRANSITIONS.CREATE_PAYMENT_WITH_3DS]: {
          target: [CHECKOUT_COM_CARD_FORM_STATES['3D_SECURE_OPEN']],
          actions: open3DSecureModal,
        },
        [CHECKOUTCOM_CARD_FORM_TRANSITIONS.RESET]: {
          target: [CHECKOUT_COM_CARD_FORM_STATES.INITIAL],
        },
      },
    },
    [CHECKOUT_COM_CARD_FORM_STATES['3D_SECURE_OPEN']]: {
      on: {
        [CHECKOUTCOM_CARD_FORM_TRANSITIONS.RESET]: {
          target: [CHECKOUT_COM_CARD_FORM_STATES.INITIAL],
        },
        [CHECKOUTCOM_CARD_FORM_TRANSITIONS.VALIDATE_3DS]: {
          target: [CHECKOUT_COM_CARD_FORM_STATES['3D_SECURE_SUCCEEDED']],
        },
      },
      entry: ['create3dsToken'],
      exit: ['remove3dsToken'],
    },
    [CHECKOUT_COM_CARD_FORM_STATES['3D_SECURE_SUCCEEDED']]: {
      on: {
        [CHECKOUTCOM_CARD_FORM_TRANSITIONS.RESET]: {
          target: [CHECKOUT_COM_CARD_FORM_STATES.INITIAL],
        },
      },
    },
    // Flow-based states
    [CHECKOUT_COM_CARD_FORM_STATES.FLOW_READY]: {
      on: {
        [CHECKOUTCOM_CARD_FORM_TRANSITIONS.FLOW_PAYMENT_COMPLETED]: {
          target: [CHECKOUT_COM_CARD_FORM_STATES.FLOW_PAYMENT_COMPLETED],
          actions: setFlowPaymentId,
        },
        [CHECKOUTCOM_CARD_FORM_TRANSITIONS.RESET]: {
          target: [CHECKOUT_COM_CARD_FORM_STATES.INITIAL],
        },
      },
    },
    [CHECKOUT_COM_CARD_FORM_STATES.FLOW_PAYMENT_COMPLETED]: {
      on: {
        [CHECKOUTCOM_CARD_FORM_TRANSITIONS.RESET]: {
          target: [CHECKOUT_COM_CARD_FORM_STATES.INITIAL],
        },
      },
    },
  },
  schema: {
    events: {} as ICheckoutComEvents,
  },
  predictableActionArguments: true,
  preserveActionOrder: true,
});
